var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c("ExecutionResultsDialog", {
        ref: "importDetailDialog",
        attrs: { title: "Fetch import details" },
      }),
      _vm._v(" "),
      _c("PageHeader", {
        attrs: { title: "Imported Data", icon: "storage", "no-padding": "" },
      }),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          staticClass: "pa-2",
          attrs: { value: !_vm.hasId, outline: "", type: "warning" },
        },
        [
          _c(
            "div",
            { staticClass: "primary--text" },
            [
              _vm._v("Sorry, we couldn't find this import.\n      "),
              _c(
                "v-btn",
                { attrs: { small: "", to: { name: "allimports" } } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("Button.ViewAllImports")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      !(_vm.loadingHasFinish && _vm.states.isLoaded)
        ? _c("PageLoader", {
            staticClass: "my-5",
            attrs: { resourceName: "import data" },
          })
        : _vm.states.isError
        ? _c(
            "v-alert",
            {
              staticClass: "my-0",
              attrs: { value: true, type: "error", outline: "" },
            },
            [
              _c("span", { staticClass: "primary--text" }, [
                _vm._v(
                  "\n      Failed to load import details, please contact Hatfield for assistance.\n    "
                ),
              ]),
            ]
          )
        : _vm.currentImport && _vm.hasId
        ? _c(
            "v-card",
            { staticClass: "elevation-1 mb-2" },
            [
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-card-title",
                        {
                          staticClass: "pb-2",
                          staticStyle: { "align-items": "baseline" },
                        },
                        [
                          _c("div", [
                            _c("div", { staticClass: "headline" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("format")(
                                      _vm.currentImport.CreatedAt
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "body-2 font-weight-light" },
                              [
                                _vm._v(
                                  "\n              Import Date\n            "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.isSystemAdmin
                            ? _c("RollbackImportAction", {
                                attrs: { importId: _vm.importId },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isTenantAdmin
                        ? _c("ImportDocuments", {
                            attrs: { documents: _vm.documents },
                          })
                        : !_vm.isTenantAdmin &&
                          _vm.documents != null &&
                          _vm.documents.length > 0
                        ? _c(
                            "div",
                            [
                              _c(
                                "div",
                                { staticClass: "title font-weight-regular" },
                                [_vm._v("Documents")]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.documents, function (document) {
                                return _c(
                                  "v-btn",
                                  {
                                    key: document,
                                    staticClass: "mx-0",
                                    attrs: {
                                      depressed: "",
                                      small: "",
                                      href: document.FilePath,
                                      download: "",
                                    },
                                  },
                                  [
                                    _c("v-icon", { staticClass: "mr-1" }, [
                                      _vm._v(
                                        "\n              save_alt\n            "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "text-none" }, [
                                      _vm._v(_vm._s(document.FileName)),
                                    ]),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticStyle: {
                        "text-align": "right",
                        "flex-shrink": "0",
                      },
                    },
                    [
                      _c("v-card-text", { staticClass: "pb-2" }, [
                        _c("div", { staticClass: "headline" }, [
                          _vm._v(_vm._s(_vm.currentImport.CocCode)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "body-2 font-weight-light" }, [
                          _vm._v("COC Code"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "div",
                            { staticClass: "title font-weight-regular" },
                            [_vm._v("Source File")]
                          ),
                          _vm._v(" "),
                          _vm.currentImport.FileDetails
                            ? _c(
                                "div",
                                { staticClass: "body-2" },
                                [
                                  _vm.currentImport.FileDetails.ImportType ==
                                  "A125"
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "mx-0",
                                          attrs: {
                                            depressed: "",
                                            small: "",
                                            download: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.downloadFile(
                                                _vm.currentImport.FileDetails
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "mr-1" },
                                            [
                                              _vm._v(
                                                "\n                save_alt\n              "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "text-transform": "none",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentImport.FileDetails
                                                    .FileName
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm.currentImport.FileDetails
                                        .ImportType == "INGESTION"
                                    ? _c(
                                        "SecondaryBtn",
                                        {
                                          staticClass: "mx-0",
                                          attrs: {
                                            icon: "description",
                                            small: "",
                                            to: {
                                              name: "dataset",
                                              params: {
                                                id: _vm.currentImport
                                                  .FileDetails.FileGuid,
                                              },
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "text-transform": "none",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentImport.FileDetails
                                                    .FileName
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c(
                                "AlertChip",
                                { attrs: { small: "", type: "warning" } },
                                [
                                  _vm._v(
                                    "\n            Source file not found.\n          "
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { md4: "", xs12: "" } },
                    [
                      _c("v-card-text", { staticClass: "pb-0" }, [
                        _c(
                          "div",
                          [
                            _c("v-switch", {
                              attrs: {
                                color: "success",
                                "hide-details": "",
                                label: "Show new data only",
                              },
                              model: {
                                value: _vm.showNewOnly,
                                callback: function ($$v) {
                                  _vm.showNewOnly = $$v
                                },
                                expression: "showNewOnly",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "divider-right",
                      class: {
                        "pt-1 pb-3":
                          _vm.stationsToShow.length === 0 &&
                          _vm.analytesToShow.length === 0,
                      },
                      attrs: { md4: "", xs12: "" },
                    },
                    [
                      _c("v-card-text", { staticClass: "pb-0" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "span",
                              { staticClass: "title font-weight-regular" },
                              [_vm._v("Stations")]
                            ),
                            _vm._v(" "),
                            [
                              _vm._v("\n              ⋅\n              "),
                              _c("span", { staticClass: "font-weight-light" }, [
                                _vm._v(
                                  _vm._s(_vm.stationsToShow.length) +
                                    "\n                " +
                                    _vm._s(
                                      _vm.pluralize(
                                        "item",
                                        _vm.stationsToShow.length
                                      )
                                    )
                                ),
                              ]),
                            ],
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.stationsToShow.length > 0
                        ? _c("v-data-table", {
                            staticClass: "table-default-bg",
                            class: {
                              "five-items":
                                _vm.pagination.stations.rowsPerPage === 5,
                              "ten-items":
                                _vm.pagination.stations.rowsPerPage === 10,
                              "twenty-five-items":
                                _vm.pagination.stations.rowsPerPage === 25,
                            },
                            attrs: {
                              pagination: _vm.pagination.stations,
                              items: _vm.stationsToShow,
                              headers: _vm.stationHeaders,
                            },
                            on: {
                              "update:pagination": function ($event) {
                                return _vm.$set(
                                  _vm.pagination,
                                  "stations",
                                  $event
                                )
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "items",
                                  fn: function (props) {
                                    return [
                                      _c("td", [
                                        _vm._v(_vm._s(props.item.SiteId)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              372553166
                            ),
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "divider-right",
                      class: {
                        "pt-1 pb-3":
                          _vm.stationsToShow.length === 0 &&
                          _vm.analytesToShow.length === 0,
                      },
                      attrs: { md4: "", xs12: "" },
                    },
                    [
                      _c("v-card-text", { staticClass: "pb-0" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "span",
                              { staticClass: "title font-weight-regular" },
                              [_vm._v("Analytes")]
                            ),
                            _vm._v(" "),
                            [
                              _vm._v("\n              ⋅\n              "),
                              _c("span", { staticClass: "font-weight-light" }, [
                                _vm._v(
                                  _vm._s(_vm.analytesToShow.length) +
                                    "\n                " +
                                    _vm._s(
                                      _vm.pluralize(
                                        "item",
                                        _vm.analytesToShow.length
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ],
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.analytesToShow.length > 0
                        ? _c("v-data-table", {
                            staticClass: "table-default-bg",
                            class: {
                              "five-items":
                                _vm.pagination.analytes.rowsPerPage == 5,
                              "ten-items":
                                _vm.pagination.analytes.rowsPerPage === 10,
                              "twenty-five-items":
                                _vm.pagination.analytes.rowsPerPage === 25,
                            },
                            attrs: {
                              items: _vm.analytesToShow,
                              headers: _vm.analyteHeaders,
                              pagination: _vm.pagination.analytes,
                            },
                            on: {
                              "update:pagination": function ($event) {
                                return _vm.$set(
                                  _vm.pagination,
                                  "analytes",
                                  $event
                                )
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "items",
                                  fn: function (props) {
                                    return [
                                      _c("td", [
                                        _vm._v(_vm._s(props.item.AnalyteName)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1042926533
                            ),
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      class: {
                        "pt-1 pb-3":
                          _vm.stationsToShow.length === 0 &&
                          _vm.analytesToShow.length === 0 &&
                          _vm.currentImport.MediaTypes.length === 0,
                      },
                      attrs: { md4: "", xs12: "" },
                    },
                    [
                      _c("v-card-text", { staticClass: "pb-0" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "span",
                              { staticClass: "title font-weight-regular" },
                              [_vm._v("MediaTypes")]
                            ),
                            _vm._v(" "),
                            [
                              _vm._v("\n              ⋅\n              "),
                              _c("span", { staticClass: "font-weight-light" }, [
                                _vm._v(
                                  _vm._s(_vm.currentImport.MediaTypes.length) +
                                    "\n                " +
                                    _vm._s(
                                      _vm.pluralize(
                                        "item",
                                        _vm.currentImport.MediaTypes.length
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ],
                          ],
                          2
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.currentImport.MediaTypes.length > 0
                        ? _c("v-data-table", {
                            staticClass: "table-default-bg",
                            class: {
                              "five-items":
                                _vm.pagination.mediaTypes.rowsPerPage === 5,
                              "ten-items":
                                _vm.pagination.mediaTypes.rowsPerPage === 10,
                              "twenty-five-items":
                                _vm.pagination.mediaTypes.rowsPerPage === 25,
                            },
                            attrs: {
                              items: _vm.currentImport.MediaTypes,
                              headers: _vm.mediaTypeHeaders,
                              pagination: _vm.pagination.mediaTypes,
                            },
                            on: {
                              "update:pagination": function ($event) {
                                return _vm.$set(
                                  _vm.pagination,
                                  "mediaTypes",
                                  $event
                                )
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "items",
                                  fn: function (props) {
                                    return [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(props.item.MediaTypeName)
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1995057523
                            ),
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _vm.currentImport.Data.length
                ? _c(
                    "v-card",
                    { staticClass: "elevation-0 mb-2" },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "pb-0 align-center" },
                        [
                          _c(
                            "span",
                            [
                              _c(
                                "span",
                                { staticClass: "title font-weight-regular" },
                                [_vm._v("Data")]
                              ),
                              _vm._v(" "),
                              [
                                _vm._v("\n            ⋅\n            "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-light" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.dataItems.length) +
                                        "\n              " +
                                        _vm._s(
                                          _vm.pluralize(
                                            "item",
                                            _vm.dataItems.length
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("v-switch", {
                            staticClass: "ml-3 my-0",
                            attrs: {
                              color: "primary",
                              "hide-details": "",
                              label: "Show details",
                            },
                            model: {
                              value: _vm.showDetails.data,
                              callback: function ($$v) {
                                _vm.$set(_vm.showDetails, "data", $$v)
                              },
                              expression: "showDetails.data",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c("v-text-field", {
                            staticClass: "rounded font-weight-regular",
                            attrs: {
                              "prepend-inner-icon": "search",
                              "hide-details": "",
                              clearable: "",
                              solo: "",
                              placeholder: "Search data",
                            },
                            on: {
                              "click:clear": function ($event) {
                                _vm.search.data = ""
                              },
                            },
                            model: {
                              value: _vm.search.data,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "data", $$v)
                              },
                              expression: "search.data",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        staticClass: "table-default-bg",
                        class: {
                          "five-items": _vm.pagination.data.rowsPerPage === 5,
                          "ten-items": _vm.pagination.data.rowsPerPage === 10,
                          "twenty-five-items":
                            _vm.pagination.data.rowsPerPage === 25,
                        },
                        attrs: {
                          search: _vm.search.data,
                          items: _vm.dataItems,
                          headers: _vm.dataHeaders,
                          pagination: _vm.pagination.data,
                        },
                        on: {
                          "update:pagination": function ($event) {
                            return _vm.$set(_vm.pagination, "data", $event)
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "items",
                              fn: function (props) {
                                return [
                                  _c("td", { staticClass: "no-wrap" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDate")(
                                          props.item.SampleDateTime
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "no-wrap" }, [
                                    _vm._v(_vm._s(props.item.SiteId)),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "no-wrap" }, [
                                    _vm._v(_vm._s(props.item.DisplayName)),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "no-wrap" }, [
                                    _vm._v(_vm._s(props.item.AnalyteName)),
                                  ]),
                                  _vm._v(" "),
                                  _vm.showDetails.data
                                    ? [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "text-xs-right no-wrap",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(props.item.ResultQualifier)
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "text-xs-right no-wrap",
                                          },
                                          [_vm._v(_vm._s(props.item.Result))]
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(props.item.Units)),
                                        ]),
                                      ]
                                    : [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "text-xs-right d-flex no-wrap",
                                            staticStyle: {
                                              "align-content": "right",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  props.item.ResultQualifier
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("v-spacer"),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(props.item.Result) +
                                                  " " +
                                                  _vm._s(props.item.Units)
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-xs-right no-wrap",
                                      class: {
                                        "error--text":
                                          props.item.isBelowDetectionLimit,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(props.item.DetectionLimit)
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "no-wrap" },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getMediaTypeIcon(
                                              props.item.MediaType
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(props.item.MediaType) +
                                          "\n          "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3829340413
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }